/* eslint-disable object-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
// DEPENDENCIES
import React, { useState } from 'react';
import { connect } from 'react-redux';
// CUSTOM COMPONENTS
import CustomBlock from '../../../components/CustomBlock';
import ContactForm from '../../../components/ContactForm';
// SERVICES AND HELPERS
import * as auth from '../../../redux/authRedux';
import * as alertToast from '../../../redux/alertToastRedux';
import * as emailService from '../../../services/management/emailService';

const ContactUsTab = (props) => {
  const { showAlert } = props;
  const [isLoading, setIsLoading] = useState(false);
  const formConfig = [
    { name: 'firstName', label: 'First Name', required: true, placeholder: 'John', max: 100 },
    { name: 'lastName', label: 'Last Name', required: true, placeholder: 'Smith', max: 100 },
    { name: 'email', label: 'Email Address', required: true, placeholder: 'johnsmith@example.com', max: 100, email: true },
    { name: 'phoneNumber', label: 'Phone Number', placeholder: '(555) 555-5555', max: 50 },
    { name: 'message', label: 'Message', required: true, placeholder: 'Provide your message here...', textarea: true, cols: 12 },
  ];

  const submitForm = async (values, { resetForm }) => {
    setIsLoading(true);

    const { reCAPTCHAToken, ...formData } = values;

    const submissionData = {
      ...formData,
      formType: 'contact-form',
      reCAPTCHAToken,
    };

    await emailService.sendEmail(submissionData).then(() => {
      showAlert({ text: 'Success! Your message has been received.', state: 'success' });
      resetForm();
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <>
      <CustomBlock className="mb-40">
        <h2 className="size-xl fw-700 secondary--clr mb-15">Get In Touch</h2>
        <p className="mid-grey--clr size-mdlg">Use the form below to send a message to <span className="fw-500">Livingston Parish Gravity Drainage District № 2</span>.</p>
      </CustomBlock>

      {/* CONTACT US FORM */}
      <ContactForm
        formConfig={formConfig}
        formType="contact-form"
        onSubmit={(values, actions) => submitForm(values, actions)}
        isSubmitting={isLoading}
        submitButtonLabel="Send Message"
      />
    </>
  );
};

const mapStateFromProps = (state) => ({ auth: state.auth });

export default connect(mapStateFromProps, {
  ...auth.actions,
  ...alertToast.actions
})(ContactUsTab);